import { create } from "zustand";

/** Chats de IA da lateral direita: cada um vem de um plugin (Claude, GitHub Copilot). */
export type AiProvider = "claude" | "copilot";

/** Abas da lateral direita: pessoas, chat do time, atividade, o agente e os chats de IA instalados. */
export type RightTab = "people" | "team" | "activity" | "agent" | AiProvider;

const TABS: readonly RightTab[] = ["people", "team", "activity", "agent", "claude", "copilot"];

function readSide(): RightTab | null {
  try {
    const v = localStorage.getItem("kompil.side") ?? localStorage.getItem("kompil.chat");
    // "1" era o chat único (Claude) das versões anteriores.
    if (v === "1") return "claude";
    return TABS.includes(v as RightTab) ? (v as RightTab) : null;
  } catch {
    return null;
  }
}

interface UiPatch {
  quickOpen: "all" | "projects" | null;
  shortcuts: boolean;
  server: boolean;
  login: string | null;
  side: RightTab | null;
  /** O chat de IA (Claude Code ou Copilot) ocupa o projeto inteiro. */
  aiFull: boolean;
  importRepo: boolean;
  importVsCode: boolean;
}

/** Janelas do app (busca rápida, diálogos da barra de título e a lateral direita). */
export const useDesktopUi = create<
  UiPatch & {
    /** Diálogo "Entrar" (app desktop: não há tela de login). Texto: por que pedimos a conta. */
    login: string | null;
    /** Aba aberta na lateral direita (como a barra lateral secundária do VS Code). */
    side: RightTab | null;
    set: (patch: Partial<UiPatch>) => void;
  }
>((set) => ({
  quickOpen: null,
  shortcuts: false,
  server: false,
  login: null,
  side: readSide(),
  aiFull: false,
  importRepo: false,
  importVsCode: false,
  set: (patch) => {
    // Lateral fechada: a tela cheia do chat de IA fecha junto.
    if (patch.side === null) patch = { ...patch, aiFull: false };
    if (patch.side !== undefined) {
      try {
        localStorage.setItem("kompil.side", patch.side ?? "");
      } catch {
        // armazenamento bloqueado: a lateral só não é lembrada
      }
    }
    set(patch);
  },
}));
